import React, { useState } from 'react'

// default role type
import { role } from '../utility/defaultData';
import { superAdminRole } from '../utility/defaultData';

// redux 
import { useSelector, shallowEqual } from "react-redux";
import { RootState } from "../../setup/redux/RootReducer";

export const useOnlyAccessPermissionForHanayAdmin = () => {

    let hanayAdmin = false

    const userData: any = useSelector<RootState>(
        ({ auth }) => auth?.user,
         shallowEqual
      );
    
    

    if(Array.isArray(role) && Array.isArray(superAdminRole)){
        hanayAdmin = [...superAdminRole,...role].some(
         (item: any) => item?.value === userData?.data?.role?.role_id
       );
   
    }
   
    return [hanayAdmin];
}


